import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { UserState } from "../models/UserState";

const setErrorEmailVendor = (state: UserState, action: PayloadAction<Error>) => {
    state.vendor.emailError = action.payload.error;
}

export default setErrorEmailVendor;